import { render } from "./PlanosDescricaoPage.vue?vue&type=template&id=16930374&scoped=true&ts=true"
import script from "./PlanosDescricaoPage.vue?vue&type=script&lang=ts"
export * from "./PlanosDescricaoPage.vue?vue&type=script&lang=ts"

import "./PlanosDescricaoPage.vue?vue&type=style&index=0&id=16930374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16930374"]])

export default __exports__